import axios from "./axios";
import language from "./language";

interface Country {
    id: number;
    name: string;
    created_at: string;
    updated_at: string;
}

export default async function (): Promise<Country[]> {
    const { data } = await axios.get("general/country/list", {
        params: {
            lang: language()
        }
    });

    if (data.message == "OK") {
        return data.data;
    }
    return [];
}
